/**
 * 사용자PC 부팅관리 — desktop/layouts/app 의 모든 화면에서 돈다 (body data-page-type 기본 Desktop)
 */
export default {
    initialize: function () {
        // 상단바 로그아웃 — 프레임 안에서 열렸어도 최상위 창을 옮긴다
        $('#uLogout').on('click', () => { top.location.href = '/logout?t=pc'; });
    }
};
